$(document).ready(function() {
  var sizeMapping = {
    '28A': 'AA',
    '30A': 'AA',
    '32A': 'AA',
    '28B': 'AA',
    '30B': 'AA',
    '28C': 'AA',
    '34A': 'A',
    '32B': 'A',
    '30C': 'A',
    '28D': 'A',
    '36A': 'B',
    '34B': 'B',
    '32C': 'B',
    '30D': 'B',
    '28DD/E': 'B',
    '38A': 'C',
    '36B': 'C',
    '34C': 'C',
    '32D': 'C',
    '30DD/E': 'C',
    '28DDD/F': 'C',
    '40A': 'D',
    '38B': 'D',
    '36C': 'D',
    '34D': 'D',
    '32DD/E': 'D',
    '30DDD/F': 'D',
    '28G': 'D',
    '42A': 'E',
    '40B': 'E',
    '38C': 'E',
    '36D': 'E',
    '34DD/E': 'E',
    '32DDD/F': 'E',
    '30G': 'E',
    '28H': 'E',
    '44A': 'F',
    '42B': 'F',
    '40C': 'F',
    '38D': 'F',
    '36DD/E': 'F',
    '34DDD/F': 'F',
    '32G': 'F',
    '30H': 'F',
    '28I': 'F',
    '44B': 'G',
    '42C': 'G',
    '40D': 'G',
    '38DD/E': 'G',
    '36DDD/F': 'G',
    '34G': 'G',
    '32H': 'G',
    '30I': 'G',
    '28J': 'G',
    '44C': 'H',
    '42D': 'H',
    '40DD/E': 'H',
    '38DDD/F': 'H',
    '36G': 'H',
    '34H': 'H',
    '32I': 'H',
    '30J': 'H',
    '28K': 'H',
    '44D': 'I',
    '42DD/E': 'I',
    '40DDD/F': 'I',
    '38G': 'I',
    '36H': 'I',
    '34I': 'I',
    '32J': 'I',
    '30K': 'I',
    '28L': 'I',
  };

  
  var variantMap = {
    'AA': '43825635852464',
    'A': '43825635983536',
    'B': '43825636114608',
    'C': '43825636245680',
    'D': '43825636376752',
    'E': '43825636507824',
    'F': '43825636638896',
    'G': '43825636769968',
    'H': '44047437529264',
    'I': '44047437660336',
  };

  var variantMapId = {
    'AA': 'template--17817554780336__main-1-0',
    'A': 'template--17817554780336__main-1-1',
    'B': 'template--17817554780336__main-1-2',
    'C': 'template--17817554780336__main-1-3',
    'D': 'template--17817554780336__main-1-4',
    'E': 'template--17817554780336__main-1-5',
    'F': 'template--17817554780336__main-1-6',
    'G': 'template--17817554780336__main-1-7',
    'H': 'template--17817554780336__main-1-8',
    'I': 'template--17817554780336__main-1-9',
  };

  var variantMapGuide = {
    'AA': 'AA',
    'A': 'A',
    'B': 'B',
    'C': 'C',
    'D': 'D',
    'E': 'E',
    'F': 'F',
    'G': 'G',
    'H': 'H',
    'I': 'I',
  };

  function filterImagesBySize(sizeMapping) {
      $('.responsive-result .splide__slide').css('width', '');
      $('.responsive-result .splide__slide img').hide();
      $('.responsive-result.splide__list').removeAttr('style');

      $(`.${sizeMapping}-size.splide__slide img`).show();
      $('.responsive-result .splide__list').css('transform', 'translateX(0px)');

      function setSlideWidth() {
        if ($(window).width() <= 767) {
          $(`.${sizeMapping}-size.splide__slide`).css('width', 'calc(100%)');
        } else {
          $(`.${sizeMapping}-size.splide__slide`).css('width', '50%');
        }
      }
    
      setSlideWidth();
    
      $(window).resize(function() {
        setSlideWidth();
      });
    }


  function updateSelectedSize(boombSize) {
    $('.pick-result-size option').removeAttr('selected');
    $(`.pick-result-size option[value="${boombSize}"]`).attr('selected', 'selected');
  }

  $('.pick-result-size').on('change', function () {
    const selectedSize2 = $(this).val();
    updateSelectedSize(selectedSize2);

    filterImagesBySize(selectedSize2);

    $('.pick-band-size').prop('selectedIndex', 0); // Resets to the first option (Band)
    $('.pick-cup-size').prop('selectedIndex', 0);  // Resets to the first option (Cup)

    $('#cup-select').prop('disabled', true);
  });

  
  $('.pick-band-size, .pick-cup-size').change(function() {
    var sizeValue1 = $('.pick-band-size').val();
    var sizeValue2 = $('.pick-cup-size').val();
    var sizeResult = sizeValue1 + sizeValue2;
    var resultSize = sizeMapping[sizeResult] || 'No data';

    $('.pick-result-size option').removeAttr('selected');
    $('.pick-result-size option').each(function() {
      if ($(this).val() === resultSize) {
        $(this).attr('selected', 'selected');
      }
    });

    filterImagesBySize(resultSize);
    
    if (sizeMapping[sizeResult]) {
      var boombSize = sizeMapping[sizeResult];
      $('.pick-result-size').val(boombSize);
      var variantId = variantMap[boombSize];
      var variantIdTemplate = variantMapId[boombSize];
      var variantSizeChart = variantMapGuide[boombSize];

      if (variantId) {
        history.replaceState(null, '', `?variant=${variantId}`);
        var variantSelector = $('[name="id"]');
        variantSelector.val(variantId).trigger('change');
        $('form[action="/cart/add"] [name="id"]').val(variantId);
        $(`.hdt-product-form__values input[id="${variantIdTemplate}"]`).prop('checked', true).trigger('change');
        $('.is-style-size legend .hdt-font-semibold[update-value]').html(`${variantSizeChart}`);
      }
    }

    function updateProductVariant(variantId) {
      $.ajax({
        url: `/get-product-details?variant=${variantId}`,
        method: 'GET',
        success: function (data) {
          $('#product-title').text(data.title);
          $('#product-price').text(data.price);
          $('#product-image').attr('src', data.imageUrl);
        },
        error: function () {
          console.error('Failed to load product details.');
        }
      });
    }
  });


    var initialSelectedValue = $('.pick-result-size').val();
    $('.pick-result-size').attr('selected-value', initialSelectedValue);

    $('.pick-result-size').on('change', function() {
      var selectedValue = $(this).val();
      $(this).attr('selected-value', selectedValue);
    });


    $('#band-select').on('change', function() {
      var selectedBand = $(this).val();
      if (selectedBand) {
        $('#cup-select').prop('disabled', false);
        $('#cup-select option').each(function() {
          if (selectedBand === "30") {
            if ($(this).val() === "L") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedBand === "32"){
            if ($(this).val() === "K" || $(this).val() === "L") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedBand === "34"){
            if ($(this).val() === "J" || $(this).val() === "K" || $(this).val() === "L") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedBand === "36"){
            if ($(this).val() === "I" || $(this).val() === "J" || $(this).val() === "K" || $(this).val() === "L") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedBand === "38"){
            if ($(this).val() === "H" || $(this).val() === "I" || $(this).val() === "J" || $(this).val() === "K" || $(this).val() === "L") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedBand === "40"){
            if ($(this).val() === "G" || $(this).val() === "H" || $(this).val() === "I" || $(this).val() === "J" || $(this).val() === "K" || $(this).val() === "L") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedBand === "42"){
            if ($(this).val() === "DDD/F" || $(this).val() === "G" || $(this).val() === "H" || $(this).val() === "I" || $(this).val() === "J" || $(this).val() === "K" || $(this).val() === "L") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedBand === "44"){
            if ($(this).val() === "DD/E" || $(this).val() === "DDD/F" || $(this).val() === "G" || $(this).val() === "H" || $(this).val() === "I" || $(this).val() === "J" || $(this).val() === "K" || $(this).val() === "L") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else {
            $(this).prop('disabled', false);
          }
        });
      } else {
        $('#cup-select').prop('disabled', true);
      }
    });

    $('#cup-select').on('change', function() {
      var selectedCup = $(this).val();
      if (selectedCup) {
        // $('#band-select').prop('disabled', false);
        $('#band-select option').each(function() {
          if (selectedCup === "DD/E") {
            if ($(this).val() === "44") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedCup === "DDD/F"){
            if ($(this).val() === "42" || $(this).val() === "44") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedCup === "G"){
            if ($(this).val() === "40" || $(this).val() === "42" || $(this).val() === "44") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedCup === "H"){
            if ($(this).val() === "38" || $(this).val() === "40" || $(this).val() === "42" || $(this).val() === "44") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedCup === "I"){
            if ($(this).val() === "36" || $(this).val() === "38" || $(this).val() === "40" || $(this).val() === "42" || $(this).val() === "44") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedCup === "J"){
            if ($(this).val() === "34" || $(this).val() === "36" || $(this).val() === "38" || $(this).val() === "40" || $(this).val() === "42" || $(this).val() === "44") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedCup === "K"){
            if ($(this).val() === "32" || $(this).val() === "34" || $(this).val() === "36" || $(this).val() === "38" || $(this).val() === "40" || $(this).val() === "42" || $(this).val() === "44") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else if (selectedCup === "L"){
            if ($(this).val() === "30" || $(this).val() === "32" || $(this).val() === "34" || $(this).val() === "36" || $(this).val() === "38" || $(this).val() === "40" || $(this).val() === "42" || $(this).val() === "44") {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else {
            $(this).prop('disabled', false);
          }
        });
      } else {
        $('#cup-select').prop('disabled', true);
      }
    });
  });